export function formatTourPrice(price) {
  return typeof price === 'number' ? `$${price}` : `$${price}`;
}

export const SERVICE_FEE_RATE = 0.05;

export function getServiceFee(amount) {
  return Number.isFinite(amount) ? Math.round(amount * SERVICE_FEE_RATE * 100) / 100 : 0;
}

export function getTotalWithServiceFee(amount) {
  return Number.isFinite(amount) ? Math.round((amount + getServiceFee(amount)) * 100) / 100 : amount;
}

const helperCopy = {
  en: {
    pickupMiamiBeach: 'Miami Beach pickup available',
    outsidePickup: 'Outside Miami Beach by request',
    callHelp: 'Call or text (305) 491-0131 for booking help',
    longTrip: 'Full-day timing and departure details confirmed after booking',
    fastConfirmation: 'Fast confirmation and pickup coordination after booking',
    checkoutPickup:
      'Pickup details are confirmed after booking. Miami Beach pickup is available on many experiences, and outside-area pickup can be arranged on request.',
    checkoutCall:
      'Yes. If you want help choosing a time, confirming pickup, or coordinating a group, you can call or text (305) 491-0131 before checkout.',
    checkoutSecure:
      'Yes. Payment is handled through Stripe, and you will be redirected to a secure checkout flow to complete your booking.',
    checkoutLongTrip:
      'This is a longer day trip, so plan for an early start and review your confirmation carefully once your date is secured.',
    checkoutStandard:
      'Review the date, guest count, and pickup location carefully so we can confirm your booking and coordination details quickly.',
    rentalPrice:
      'Your total is based on the vehicle category you select and the full pickup-to-drop-off rental window. Partial days are rounded into the next rental day so the final total stays clear before payment.',
    rentalIncluded:
      'Basic insurance is included with economy, standard, convertible, and SUV rental categories. Luxury and exotic requests are quoted separately.',
    rentalCustom:
      'Yes. If you want a specific model, luxury vehicle, or something outside the listed categories, call or text (305) 491-0131 and we can quote it directly.',
    rentalReview:
      'Review your pickup date, pickup time, drop-off date, and drop-off time carefully so we can coordinate the rental correctly and lock in the right total.',
    whenPickupQuestion: 'When do I get my pickup details?',
    callQuestion: 'Can I call before booking {tourName}?',
    secureQuestion: 'Is checkout secure?',
    knowQuestion: 'What should I know before booking {tourName}?',
    rentalPriceQuestion: 'How is Miami Car Rental pricing calculated?',
    rentalIncludedQuestion: 'What is included with the rental rate?',
    rentalCustomQuestion: 'Can I request a different vehicle for {tourName}?',
    rentalReviewQuestion: 'What should I double-check before paying?',
  },
  es: {
    pickupMiamiBeach: 'Recogida disponible en Miami Beach',
    outsidePickup: 'Recogida fuera de Miami Beach a solicitud',
    callHelp: 'Llama o escribe al (305) 491-0131 para ayuda con tu reserva',
    longTrip: 'Los horarios y detalles de salida de día completo se confirman después de reservar',
    fastConfirmation: 'Confirmación rápida y coordinación de recogida después de reservar',
    checkoutPickup:
      'Los detalles de recogida se confirman después de reservar. Hay recogida en Miami Beach en muchas experiencias, y la recogida fuera del área se puede coordinar a solicitud.',
    checkoutCall:
      'Sí. Si quieres ayuda para elegir una hora, confirmar la recogida o coordinar un grupo, puedes llamar o escribir al (305) 491-0131 antes de pagar.',
    checkoutSecure:
      'Sí. El pago se maneja a través de Stripe y serás redirigido a un flujo seguro para completar tu reserva.',
    checkoutLongTrip:
      'Este es un viaje más largo, así que planifica una salida temprana y revisa tu confirmación con cuidado una vez que asegures tu fecha.',
    checkoutStandard:
      'Revisa bien la fecha, cantidad de personas y lugar de recogida para que podamos confirmar tu reserva y coordinarla rápidamente.',
    rentalPrice:
      'El total se basa en la categoría de vehículo que selecciones y en toda la ventana de recogida a entrega. Los días parciales se redondean al siguiente día de alquiler para que el total quede claro antes de pagar.',
    rentalIncluded:
      'El seguro básico está incluido en las categorías económica, estándar, convertible y SUV. Las solicitudes de lujo y exóticos se cotizan por separado.',
    rentalCustom:
      'Sí. Si quieres un modelo específico, un vehículo de lujo o algo fuera de las categorías listadas, llama o escribe al (305) 491-0131 y te lo cotizamos directamente.',
    rentalReview:
      'Revisa bien tu fecha y hora de recogida, así como la fecha y hora de entrega, para que podamos coordinar el alquiler correctamente y fijar el total correcto.',
    whenPickupQuestion: '¿Cuándo recibo los detalles de recogida?',
    callQuestion: '¿Puedo llamar antes de reservar {tourName}?',
    secureQuestion: '¿El pago es seguro?',
    knowQuestion: '¿Qué debo saber antes de reservar {tourName}?',
    rentalPriceQuestion: '¿Cómo se calcula el precio de la renta de autos en Miami?',
    rentalIncludedQuestion: '¿Qué incluye la tarifa del alquiler?',
    rentalCustomQuestion: '¿Puedo pedir un vehículo diferente para {tourName}?',
    rentalReviewQuestion: '¿Qué debo revisar bien antes de pagar?',
  },
  fr: {
    pickupMiamiBeach: 'Prise en charge disponible à Miami Beach',
    outsidePickup: 'Prise en charge hors de Miami Beach sur demande',
    callHelp: 'Appelez ou envoyez un message au (305) 491-0131 pour obtenir de l’aide',
    longTrip: 'Les horaires et détails de départ pour cette excursion d’une journée sont confirmés après la réservation',
    fastConfirmation: 'Confirmation rapide et coordination de la prise en charge après la réservation',
    checkoutPickup: 'Les détails de prise en charge sont confirmés après la réservation. La prise en charge à Miami Beach est disponible pour de nombreuses expériences, et les autres zones peuvent être organisées sur demande.',
    checkoutCall: 'Oui. Si vous souhaitez de l’aide pour choisir une heure, confirmer une prise en charge ou organiser un groupe, appelez ou envoyez un message au (305) 491-0131 avant le paiement.',
    checkoutSecure: 'Oui. Le paiement est traité par Stripe et vous serez redirigé vers un paiement sécurisé pour finaliser votre réservation.',
    checkoutLongTrip: 'Il s’agit d’une excursion plus longue : prévoyez un départ matinal et consultez attentivement votre confirmation une fois la date réservée.',
    checkoutStandard: 'Vérifiez attentivement la date, le nombre de participants et le lieu de prise en charge afin que nous puissions confirmer rapidement votre réservation.',
    rentalPrice: 'Le total dépend de la catégorie de véhicule choisie et de toute la période entre la prise en charge et la restitution. Les journées partielles sont arrondies au jour de location suivant afin que le total soit clair avant le paiement.',
    rentalIncluded: 'L’assurance de base est incluse pour les catégories économique, standard, cabriolet et SUV. Les demandes de véhicules de luxe sont proposées séparément sur devis.',
    rentalCustom: 'Oui. Si vous souhaitez un modèle précis, un véhicule de luxe ou une option qui ne figure pas dans la liste, appelez ou envoyez un message au (305) 491-0131 et nous vous proposerons un devis.',
    rentalReview: 'Vérifiez attentivement les dates et heures de prise en charge et de restitution afin que nous puissions organiser correctement votre location et calculer le bon total.',
    whenPickupQuestion: 'Quand recevrai-je les détails de prise en charge ?',
    callQuestion: 'Puis-je appeler avant de réserver {tourName} ?',
    secureQuestion: 'Le paiement est-il sécurisé ?',
    knowQuestion: 'Que dois-je savoir avant de réserver {tourName} ?',
    rentalPriceQuestion: 'Comment le prix de la location de voiture à Miami est-il calculé ?',
    rentalIncludedQuestion: 'Qu’est-ce qui est inclus dans le tarif de location ?',
    rentalCustomQuestion: 'Puis-je demander un autre véhicule pour {tourName} ?',
    rentalReviewQuestion: 'Que dois-je vérifier avant de payer ?',
  },
};

export function getBookingDateTimeValue(date, time) {
  if (!date || !time) return null;

  const normalizedTime = /^\d{2}:\d{2}$/.test(String(time)) ? `${time}:00` : String(time);
  const value = new Date(`${date}T${normalizedTime}`);

  return Number.isNaN(value.getTime()) ? null : value;
}

export function formatBookingDateTime(date, time, language = 'en') {
  const value = getBookingDateTimeValue(date, time);

  if (!value) {
    return [date, time].filter(Boolean).join(' ');
  }

  const locale = language === 'es' ? 'es-ES' : language === 'pt' ? 'pt-BR' : language === 'fr' ? 'fr-FR' : 'en-US';
  return new Intl.DateTimeFormat(locale, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(value);
}

export function getRentalDurationDays(pickupDate, pickupTime, dropoffDate, dropoffTime) {
  const pickup = getBookingDateTimeValue(pickupDate, pickupTime);
  const dropoff = getBookingDateTimeValue(dropoffDate, dropoffTime);

  if (!pickup || !dropoff || dropoff <= pickup) {
    return 0;
  }

  const durationMs = dropoff.getTime() - pickup.getTime();
  const dayMs = 1000 * 60 * 60 * 24;

  return Math.max(1, Math.ceil(durationMs / dayMs));
}

function getPricingModel(tour, price) {
  if (tour?.pricingModel) return tour.pricingModel;
  return typeof price === 'number' ? 'per_person' : 'flat_rate';
}

export function getPricePrefix(price, tour) {
  if (tour?.pricePrefix) return tour.pricePrefix;
  if (getPricingModel(tour, price) === 'per_booking') return 'Starting from';
  return typeof price === 'number' ? 'From' : 'Rate';
}

export function getPriceSuffix(price, tour) {
  if (typeof tour?.priceSuffix === 'string') return tour.priceSuffix;
  return getPricingModel(tour, price) === 'per_person' ? '/ person' : '';
}

export function getCheckoutAmount(tour, guests) {
  if (typeof tour?.price !== 'number') {
    return tour?.price;
  }

  if (Number.isFinite(tour?.rentalDays) && tour.rentalDays > 0) {
    return tour.price * tour.rentalDays;
  }

  const quantity = getPricingModel(tour, tour.price) === 'per_booking' ? 1 : guests;
  return tour.price * quantity;
}

export function getCheckoutTotal(tour, guests) {
  const amount = getCheckoutAmount(tour, guests);

  if (typeof amount === 'number') {
    return `$${amount}`;
  }

  return formatTourPrice(amount);
}

export function getGoodForTags(tour) {
  if (!tour) return [];

  const text = `${tour.name} ${tour.description}`.toLowerCase();
  const tags = [];

  if (tour.category === 'Water') tags.push('Groups');
  if (tour.category === 'Adventure') tags.push('Day trip');
  if (tour.category === 'Cultural') tags.push('Sightseeing');
  if (text.includes('private')) tags.push('Private option');
  if (text.includes('family') || text.includes('groups')) tags.push('Families');
  if (text.includes('party') || text.includes('yacht') || text.includes('boat')) tags.push('Friends');
  if (text.includes('pickup') || text.includes('transport')) tags.push('Easy logistics');
  if (text.includes('key west') || text.includes('bahamas') || text.includes('orlando')) tags.push('Full-day trip');
  if (text.includes('snorkel') || text.includes('reef')) tags.push('Water lovers');
  if (text.includes('city') || text.includes('tour')) tags.push('First-time visitors');

  return [...new Set(tags)].slice(0, 4);
}

export function getBookingReassurance(tour, language = 'en') {
  const copy = helperCopy[language] || helperCopy.en;
  const notes = [
    copy.pickupMiamiBeach,
    copy.outsidePickup,
    copy.callHelp,
  ];

  if (!tour) {
    return notes;
  }

  const text = `${tour.name} ${tour.description}`.toLowerCase();

  if (text.includes('key west') || text.includes('bahamas') || text.includes('orlando')) {
    notes.push(copy.longTrip);
  } else {
    notes.push(copy.fastConfirmation);
  }

  return notes.slice(0, 4);
}

export function getCheckoutFaqs(tour, language = 'en') {
  const copy = helperCopy[language] || helperCopy.en;
  const tourName = tour?.name || 'this experience';
  const text = `${tour?.name || ''} ${tour?.description || ''}`.toLowerCase();

  if (tour?.id === 7) {
    return [
      {
        question: copy.rentalPriceQuestion,
        answer: copy.rentalPrice,
      },
      {
        question: copy.rentalIncludedQuestion,
        answer: copy.rentalIncluded,
      },
      {
        question: copy.rentalCustomQuestion.replace('{tourName}', tourName),
        answer: copy.rentalCustom,
      },
      {
        question: copy.rentalReviewQuestion,
        answer: copy.rentalReview,
      },
    ];
  }

  return [
    {
      question: copy.whenPickupQuestion,
      answer: copy.checkoutPickup,
    },
    {
      question: copy.callQuestion.replace('{tourName}', tourName),
      answer: copy.checkoutCall,
    },
    {
      question: copy.secureQuestion,
      answer: copy.checkoutSecure,
    },
    {
      question: copy.knowQuestion.replace('{tourName}', tourName),
      answer: text.includes('key west') || text.includes('bahamas') || text.includes('orlando')
        ? copy.checkoutLongTrip
        : copy.checkoutStandard,
    },
  ];
}
